export default __webpack_public_path__ + "12d696dd171e300b2fabf46ea9d280db.svg";